import type { GetAvailabilitiesRequest, GetAvailabilitiesResponse } from "../shared/web/schema/getAvailabilities";
import type { GetDownloadUrisResponse } from "../shared/web/schema/getDownloadUris";
import type { GetNearestAvailabilitiesRequest } from "../shared/web/schema/getNearestAvailabilities";
import type { GetStoresResponse } from "../shared/web/schema/getStores";
import { stringToBase64 } from "../util/Base64";
import type { ReservationData } from "../util/useReservationState";
import type { Group, PostReserveResponse, ReservationDetailData, StatusData } from "./ApiData";

export default class Api {
  readonly domain;
  constructor(domain: string) {
    this.domain = domain;
  }
  private async request<T>(path: string, body?: any) {
    const { protocol, hostname, port } = window.location;
    const apiHost = hostname.replace(/^reserve\./, `api.`);
    const portSuffix = port ? `:${port}` : "";
    const uri = `${protocol}//${apiHost}${portSuffix}/v1/app/${this.domain}${path}`;
    let bodyString: string | undefined;
    if (body) {
      bodyString = JSON.stringify(body);
    }
    console.log(bodyString);

    const response = await fetch(uri, { body: bodyString, headers: { "Content-Type": "application/json" }, method: "POST" });

    if (response.ok && 200 <= response.status && response.status < 300) {
      return (await response.json()) as T;
    } else {
      const errorData = await response.json();
      alert(`エラーが発生しました。\n${errorData.error}`);
      return null;
    }
  }

  readonly GetGroup = () => this.request<Group>("/get-group");
  readonly GetStores = (group_id: number, isSourceGoogle: boolean) => this.request<GetStoresResponse>("/get-stores", { group_id, isSourceGoogle });

  readonly GetAvailability = (params: GetAvailabilitiesRequest) => this.request<GetAvailabilitiesResponse>("/get-availabilities", params);

  readonly GetNearestAvailability = (params: GetNearestAvailabilitiesRequest) => this.request<GetAvailabilitiesResponse>("/get-nearest-availabilities", params);

  PostReserve(resvData: ReservationData, eventId: string, searchParams: URLSearchParams): Promise<PostReserveResponse | null> {
    if (!resvData.store || !resvData.course || !resvData.date) {
      return Promise.resolve(null);
    }

    return this.request<PostReserveResponse>("/reserve", {
      // Facebookなどの広告媒体からCVした際のパラメータ解析用にサーバー側にSPAのクエリ文字列を送る
      analytics_queries: stringToBase64(searchParams.toString()),
      event_id: eventId,
      eventSourceUrl: window.location.href,
      fbc: resvData.fbc,
      fbp: resvData.fbp,
      group_id: resvData.group.id,
      mail: resvData.mail,
      name: resvData.name,
      phone: resvData.phone,
      request: resvData.request,
      rwg_token: resvData.rwg_token,
      staff_id: resvData.staff?.id,
      start_at: resvData.date,
      store_id: resvData.store.id,
      treatment_course_id: resvData.course.id,
      utm_campaign: resvData.utmParams.utmCampaign,
      utm_content: resvData.utmParams.utmContent,
      utm_medium: resvData.utmParams.utmMedium,
      utm_source: resvData.utmParams.utmSource,
      utm_term: resvData.utmParams.utmTerm,
    });
  }

  getReservationData = (rid: string) => {
    return this.request<ReservationDetailData>("/get-reservation-detail", { rid });
  };

  cancelReservation = (rid: string) => {
    return this.request<StatusData>("/cancel-reservation", { rid });
  };

  getFiles = async (uuids: string[]) => {
    const signedUris = await this.request<GetDownloadUrisResponse>("/get-download-uris", { uuids });
    if (!signedUris) {
      return null;
    }

    const blobs = await Promise.all(
      signedUris.map(({ uuid, uri }) => {
        return fetch(uri)
          .then((res) => res.blob())
          .then((blob) => ({ blob, uuid }));
      }),
    );
    return blobs;
  };
}
